import createReactComponent from '../createReactComponent';
export default createReactComponent('bike', 'IconBike', [
  ['path', { d: 'M5 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-0' }],
  ['path', { d: 'M19 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-1' }],
  ['path', { d: 'M12 19l0 -4l-3 -3l5 -4l2 3l3 0', key: 'svg-2' }],
  ['path', { d: 'M17 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-3' }],
]);
